import React, { useEffect, useContext, useState, useRef } from "react";
import moment from "moment";
import { Table, Space, Button, Input} from "antd";
import { OnboardingColaboradorService } from "services/OnboardingColaboradorService";
import { ContratoService } from "services/ContratoService";
import { useModalRechazarOnboarding, useModalVisorPdf } from "store/global";
import { SecurityContext } from "context/SecurityContextProvider";
import {
  SearchOutlined,
} from '@ant-design/icons';
import FormularioSeguimientoService from "services/FormularioSeguimientoService";
import { useAtom } from "jotai";
import { detalleIdAtom } from "../../ConsultaOnboardingStore";
import Highlighter from "react-highlight-words";

function TablaListar() {

    const [envioOnboarding, setEnvioOnboarding]= useState([]);
    const { getUsuarioAutenticado } = useContext(SecurityContext);
    const mostrarModalVisorPdf = useModalVisorPdf((state) => state.mostrarModal); 
    const cerrarModalVisorPdf = useModalVisorPdf((state) => state.cerrarModal); 
    const cerrarModalRechazo = useModalRechazarOnboarding((state) => state.cerrarModal); 
    const botonRechazo = useModalVisorPdf((state) => state.botonRechazo); 
    const mostrarModalRechazoOnboarding = useModalRechazarOnboarding((state) => state.mostrarModal); 
    const finProcesoRechazoOnboarding = useModalRechazarOnboarding((state) => state.finProceso); 
    const finProcesoAceptaOnboarding = useModalVisorPdf((state) => state.finProceso); 
    const rechazarOnboarding = useModalVisorPdf(state => state.rechazarOnboarding);
    const [detalleId,setDetalleId] =useAtom(detalleIdAtom);

    const isTrinyrent = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20557919962";

    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);

    useEffect(() => {
     const CargarDatos = async() =>{
        const _envioOnboarding = await OnboardingColaboradorService.listar();
        setEnvioOnboarding(_envioOnboarding)
     }
     CargarDatos();
    }, [])
    
    const onClickBtnVerDocumento = async ({fila}) => {
      
      try {
       // setLoading(true);
        // let respuesta = null;
        // if (envio.categoriaDocumentoId === CategoriaDocumento.FORMULARIOS.id) {
        //   respuesta = await FormularioSeguimientoService.getUrlDocumento(
        //     getUsuarioAutenticado().empresaSeleccionada.id,
        //     envio.id
        //   );
        // } else {
        const respuesta = await FormularioSeguimientoService.getUrlDocumento(
          getUsuarioAutenticado().empresaSeleccionada.id,
          fila.id
        );
        setDetalleId(fila.id);
        mostrarModalVisorPdf(respuesta.urlDocumento, fila.nombreDocumento, false, false, "ONBOARDING", fila.id );
      } catch (error) {
        console.error(error);
      } finally {
       // setLoading(false);
      }
    };

    useEffect(() => {
      if(botonRechazo)
          mostrarModalRechazoOnboarding(detalleId);
      else if(finProcesoAceptaOnboarding){
        const actualizarData = async() =>{
          cerrarModalVisorPdf();
          const _envioOnboarding = await OnboardingColaboradorService.listar();
          setEnvioOnboarding(_envioOnboarding)
        }
        actualizarData();
      }

    }, [botonRechazo, , finProcesoAceptaOnboarding])

    useEffect(() => {
      if(finProcesoRechazoOnboarding){
        const actualizarData = async() =>{
          cerrarModalRechazo();
          rechazarOnboarding();
          cerrarModalVisorPdf();
          const _envioOnboarding = await OnboardingColaboradorService.listar();
          setEnvioOnboarding(_envioOnboarding)
        }
        actualizarData();
      }

    }, [finProcesoRechazoOnboarding])

    var adicionarColumnasFiltro = function getColumns(dataIndex, placeholder, propiedad) {
        return {
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
              <Input
                ref={searchInput}
                placeholder={placeholder !== undefined ? placeholder : `Buscar por ${dataIndex}`}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                style={{ width: 188, marginBottom: 8, display: "block" }}
              />
              <Space>
                <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                >
                  Buscar
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  Limpiar
                </Button>
              </Space>
            </div>
          ),
          filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
          onFilter: (value, record) =>
            propiedad === undefined
              ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
              : record[dataIndex][propiedad].toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => searchInput.current.select());
            }
          },
          render: (text) =>
            searchedColumn === dataIndex ? (
              <Highlighter
                highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={propiedad === undefined ? text.toString() : text[propiedad].toString()}
              />
            ) : propiedad === undefined ? (
              text
            ) : (
              text[propiedad]
            ),
        };
      };

    const columnas = [

      {
        title: "Código de Trabajador",
        dataIndex: ["colaborador","codigo"],
      }, 
      {
        title: "Documento de Identidad",
        dataIndex: "colaborador",
        //dataIndex: ["colaborador","numeroDocumentoIdentidad"],
        //render: (text, fila) =>  fila.colaborador.codigo?.length>0?fila.colaborador.codigo:"-",
        ...adicionarColumnasFiltro("colaborador", "Buscar por Documento", "numeroDocumentoIdentidad"),
      }, 
        {
          title: "Colaborador",
          dataIndex: ["colaborador","nombreCompleto"],    
        },
        {
          title: "Documento",
          dataIndex: "nombreDocumento"   
        },
        {
          title: isTrinyrent ? "Fecha Envio" : "Periodo",
          dataIndex: isTrinyrent ? "fechaEnvio" : "periodo",
          render: (text) => isTrinyrent
            ? (text ? moment(text).format("DD/MM/YYYY") : "-")
            : text,
        },
        {
          title: "Acciones",
          align: "center",
          align: "center",
          render: (text, fila) => (
              <a onClick={() => onClickBtnVerDocumento(fila={fila})} className="custom-color-element">
                <SearchOutlined /> Ver Documento
              </a>
          )
        },
        
      ];


  function handleSearch(selectedKeys, confirm, dataIndex) {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	}

	function handleReset(clearFilters) {
		clearFilters();
		setSearchText("");
	}

    return(
        <Table
        rowKey={(detalleEnvio) => detalleEnvio.id}
        dataSource={envioOnboarding}
        columns={columnas}
      />
    )
}
export default TablaListar;